import { IconChevronChevronDown } from '@doltech/icons/IconChevronChevronDown';
import { Popover } from 'antd';
import cl from 'classnames';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { Transforms } from 'slate';
import { ReactEditor, useSlateStatic } from 'slate-react';
import styled from 'styled-components';

import { colorsV2 } from '../../../../colors-v2';
import { CardLogicCellPopoverMenu } from '../Element/Cell/CardLogicCellPopoverMenu';
import { CardLogicHeaderPopoverMenu } from '../Element/Header/CardLogicHeaderPopoverMenu';

type ActionMenuVariant = 'HEADER_CELL' | 'CELL';

const Main = styled.div`
  display: grid;
  &.HEADER_CELL {
    place-items: center;
  }

  button {
    padding: 0;
    border: 0;
    margin: 0;
    background-color: transparent;
  }

  .action-icon {
    font-size: 14px;
    line-height: 0;
    cursor: pointer;
    transition: all 0.2s ease;

    .icon-wrapper {
      pointer-events: none;
      width: 16px;
      height: 16px;
      background: ${colorsV2.white100};
      border: 1px solid ${colorsV2.gray80};
      border-radius: 4px;
      color: ${colorsV2.black100};
      display: grid;
      place-items: center;
      transition: all 0.4s ease;
    }
    &:hover,
    &:active {
      .icon-wrapper {
        background: ${colorsV2.black100};
        color: ${colorsV2.white100};
      }
    }
    &:active {
      transform: scale(0.95);
    }
  }
`;

interface CardLogicActionMenuProps {
  variant: ActionMenuVariant;
  element: any;
}

export const CardLogicActionMenu = observer((props: CardLogicActionMenuProps) => {
  const { variant, element } = props;
  const editor = useSlateStatic();
  return (
    <Main contentEditable={false} className={cl('card-logic-action-menu', variant)}>
      <Popover
        trigger="click"
        overlayClassName="no-arrow with-menu"
        placement="rightTop"
        title={
          variant === 'HEADER_CELL' ? (
            <CardLogicHeaderPopoverMenu element={element} />
          ) : (
            <CardLogicCellPopoverMenu element={element} />
          )
        }
      >
        <button
          onClick={(e) => {
            e.preventDefault();
            const path = ReactEditor.findPath(editor as any, element);
            Transforms.select(editor, path);
            Transforms.collapse(editor, { edge: 'end' });
          }}
          type="button"
          className="action-icon"
        >
          <div className="icon-wrapper">
            <IconChevronChevronDown />
          </div>
        </button>
      </Popover>
    </Main>
  );
});
